var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"project-canvas"},[_c('Canvas',{ref:"canvas",attrs:{"shapes":_vm.shapes,"image":_vm.image,"tool":_vm.selectedTool},on:{"loaded":function($event){return _vm.$emit('loaded', $event)}}}),(_vm.selectedTool != null)?_c('ToolOverlay',{attrs:{"tool":_vm.selectedTool}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }